import api from "../../api/index.js";

const state = {
  MemorialHallSearchApiModelList: [],
};

const getters = {};

const actions = {
  // 获取纪念馆权限
  GetMemberMemberMemorialHallById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/Member/GetMemberMemorialHallById",
        payload,
        (res) => {
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  // 获取会员信息
  GetMemberMemberInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/Member/GetMemberInfo",
        payload,
        (res) => {
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  // 获取会员信息跟id地址
  GetMemberMemberInfoAreaIndex({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/Member/GetMemberInfoAreaIndex",
        payload,
        (res) => {
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  // 更新会员信息
  GetMemberUpdateMemberVue({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/Member/UpdateMemberVue",
        payload,
        (res) => {
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  // 更新会员密码
  MemberUpdateMemberPasswordVue({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/Member/UpdateMemberPasswordVue",
        payload,
        (res) => {
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  // 好友转账
  MemberFriendTransfer({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/Member/FriendTransferVue",
        payload,
        (res) => {
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  GetUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/Member/GetUser",
        payload,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  GetMemberState({commit},payload)
  {
    return new Promise((resolve, reject) => {
      api.get(
        "/Member/GetMemberState",
        payload,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });

  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
